import dayjs from 'dayjs';
import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import CustomLabel from 'components/customLabel';
import ErrorMessage from 'components/errorMessage';
import { inputDataPicker } from 'components/InitialStyle';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

type ComponentTypes = {
  name?: any;
  error?: any;
  control?: any;
  label?: string;
  blockDate?: any;
  required?: boolean;
  defaultValue?: any;
  disabled?: boolean;
  endDisableDate?: any;
  disablePast?: boolean;
  startDisableDate?: any;
  disableFuture?: boolean;
};

const CustomDataPicker = ({
  label = '',
  name,
  error,
  control,
  disabled,
  blockDate,
  defaultValue,
  disableFuture,
  endDisableDate,
  required = true,
  startDisableDate,
  disablePast = false,
}: ComponentTypes) => {
  const isDateBlocked = (date: any) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    return formattedDate <= blockDate;
  };

  const rangeDisabled = (date: any) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    return formattedDate < startDisableDate || formattedDate > endDisableDate;
  };

  return (
    <Box width='100%' position='relative'>
      <CustomLabel htmlFor={label}>{label}</CustomLabel>
      <div style={{ marginTop: '5px' }}></div>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required && 'Поле обязательное для заполнения',
        }}
        defaultValue={defaultValue}
        render={({ field }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              {...field}
              format='DD/MM/YYYY'
              views={['year', 'month', 'day']}
              disabled={disabled}
              disablePast={disablePast}
              disableFuture={disableFuture}
              sx={inputDataPicker(Boolean(error?.[name]?.type))}
              value={field.value !== undefined ? dayjs(field.value) : null}
              shouldDisableDate={startDisableDate && endDisableDate ? rangeDisabled : isDateBlocked}
              onChange={(newValue) => {
                const date = dayjs(newValue).format('YYYY-MM-DD');
                field.onChange(date);
              }}
            />
          </LocalizationProvider>
        )}
      />
      <ErrorMessage error={error} name={name} />
    </Box>
  );
};

export default CustomDataPicker;
